import React, { useState } from 'react';

const Looker_Child = ({ onAdd }) => {
  const [name, setName] = useState('');
  const [url_looker, setUrl_looker] = useState('');

  const handleAdd = () => {
    if (name && url_looker) {
      onAdd({
        childCardName: name,
        url_looker,
        reportId: "hard_coded_123",
        groupId: "hard_coded_123",

      });
      setName('');
      setUrl_looker('');
    }
  };

  return (
    <div className="p-6 rounded-lg w-full">
      <div className="flex items-center space-x-4">
        <div className="flex-1">
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-600 mb-2"
          >
            Name <span className='text-red-500'>*</span>
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
            className="w-full px-4 py-2 border rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        <div className="flex-1">
          <label
            htmlFor="lookerUrl"
            className="block text-sm font-medium text-gray-600 mb-2"
          >
            Looker URL <span className='text-red-500'>*</span>
          </label>
          <input
            type="text"
            id="lookerUrl"
            name="lookerUrl"
            value={url_looker}
            onChange={(e) => setUrl_looker(e.target.value)}
            placeholder="Enter Looker URL"
            className="w-full px-4 py-2 border rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>
      </div>

      <div className="flex mt-4 justify-start items-center space-x-4">
        <button
          type="button"
          onClick={handleAdd}
          className="px-6 py-2 bg-green-600 text-white rounded-lg font-medium shadow-md hover:bg-green-700 focus:ring-2 focus:ring-green-500"
        >
          Add Another
        </button>
      </div>
    </div>
  );
};

export default Looker_Child;
